import "react-datepicker/dist/react-datepicker.css"
import { useFormContext } from "react-hook-form"
import getInputValidationClasses from "../../../lib/helpers/getInputValidationClasses"
import { input } from "../../common/form/input.module.css"
import InputGroup from "../../common/form/inputGroup"
import Label from "../../common/form/label"
import { ErrorMessage } from "../errorMessage"

export default function Details({ giftType }) {
  const { register, control } = useFormContext()
  return (
    <>
      {giftType == "memorialGift" && (
        <>
          <InputGroup>
            <Label name="firstName" required={true}>
              Förnamn på den som{" "}
              {giftType === "memorialGift" ? "hedras" : "hyllas"}
            </Label>
            <input
              id="firstName"
              {...register("firstName", {
                required: true
              })}
              className={[
                input,
                getInputValidationClasses("firstName", control)
              ].join(" ")}
            />
            <ErrorMessage name="firstName" />
          </InputGroup>

          <InputGroup>
            <Label name="lastName" required={true}>
              Efternamn på den som{" "}
              {giftType === "memorialGift" ? "hedras" : "hyllas"}
            </Label>
            <input
              id="lastName"
              {...register("lastName", {
                required: true
              })}
              className={[
                input,
                getInputValidationClasses("lastName", control)
              ].join(" ")}
            />
            <ErrorMessage name="lastName" />
          </InputGroup>
        </>
      )}

      {giftType !== "memorialGift" && (
        <InputGroup>
          <Label name="firstName" required={false}>
            Namn på den som ska hyllas
          </Label>
          <input
            id="firstName"
            {...register("firstName", {})}
            placeholder="Lämna fältet tomt om du vill fylla i för hand."
            className={[
              input,
              getInputValidationClasses("firstName", control)
            ].join(" ")}
          />
          <ErrorMessage name="firstName" />
        </InputGroup>
      )}
    </>
  )
}
